type ProjectEnvVariablesType = {
  VITE_ENABLE_SOCIAL_NETWORK_MOCK: string;
  VITE_ENABLE_TICKETS_MOCK: string;
  VITE_ENABLE_TRAININGS_MOCK: string;
  VITE_ENABLE_CHECKLIST_MOCK: string;
  VITE_GENERATE_SOURCEMAP: string;
  VITE_APP_API_URL: string;
  VITE_APP_NEWS_API_URL: string;
  VITE_APP_CHATWOOT_BASE_URL: string;
  VITE_APP_CHATWOOT_INBOX_IDENTIFIER: string;
  VITE_APP_GOOGLE_CLIENT_ID: string;
};

const projectEnvVariables: ProjectEnvVariablesType = {
  VITE_ENABLE_SOCIAL_NETWORK_MOCK: '${VITE_ENABLE_SOCIAL_NETWORK_MOCK}',
  VITE_ENABLE_TICKETS_MOCK: '${VITE_ENABLE_TICKETS_MOCK}',
  VITE_ENABLE_TRAININGS_MOCK: '${VITE_ENABLE_TRAININGS_MOCK}',
  VITE_ENABLE_CHECKLIST_MOCK: '${VITE_ENABLE_CHECKLIST_MOCK}',
  VITE_GENERATE_SOURCEMAP: '${VITE_GENERATE_SOURCEMAP}',
  VITE_APP_API_URL: '${VITE_APP_API_URL}',
  VITE_APP_NEWS_API_URL: '${VITE_APP_NEWS_API_URL}',
  VITE_APP_CHATWOOT_BASE_URL: '${VITE_APP_CHATWOOT_BASE_URL}',
  VITE_APP_CHATWOOT_INBOX_IDENTIFIER: '${VITE_APP_CHATWOOT_INBOX_IDENTIFIER}',
  VITE_APP_GOOGLE_CLIENT_ID: '${VITE_APP_GOOGLE_CLIENT_ID}',
};

// Each value is either substituted at container start (envsubst replaces the
// "${VITE_*}" placeholder) or, when that didn't happen, read from the build-time
// import.meta.env. The placeholder still containing "VITE_" means "not injected".
const resolve = (placeholder: string, buildTime: unknown): string =>
  placeholder.includes('VITE_') ? (buildTime as string) : placeholder;

export const getProjectEnvVariables = (): {
  envVariables: ProjectEnvVariablesType;
} => {
  return {
    envVariables: {
      VITE_ENABLE_SOCIAL_NETWORK_MOCK: resolve(
        projectEnvVariables.VITE_ENABLE_SOCIAL_NETWORK_MOCK,
        import.meta.env.VITE_ENABLE_SOCIAL_NETWORK_MOCK,
      ),
      VITE_ENABLE_TRAININGS_MOCK: resolve(
        projectEnvVariables.VITE_ENABLE_TRAININGS_MOCK,
        import.meta.env.VITE_ENABLE_TRAININGS_MOCK,
      ),
      VITE_ENABLE_CHECKLIST_MOCK: resolve(
        projectEnvVariables.VITE_ENABLE_CHECKLIST_MOCK,
        import.meta.env.VITE_ENABLE_CHECKLIST_MOCK,
      ),
      VITE_ENABLE_TICKETS_MOCK: resolve(
        projectEnvVariables.VITE_ENABLE_TICKETS_MOCK,
        import.meta.env.VITE_ENABLE_TICKETS_MOCK,
      ),
      VITE_GENERATE_SOURCEMAP: resolve(
        projectEnvVariables.VITE_GENERATE_SOURCEMAP,
        import.meta.env.VITE_GENERATE_SOURCEMAP,
      ),
      VITE_APP_API_URL: resolve(projectEnvVariables.VITE_APP_API_URL, import.meta.env.VITE_APP_API_URL),
      VITE_APP_NEWS_API_URL: resolve(projectEnvVariables.VITE_APP_NEWS_API_URL, import.meta.env.VITE_APP_NEWS_API_URL),
      VITE_APP_CHATWOOT_BASE_URL: resolve(
        projectEnvVariables.VITE_APP_CHATWOOT_BASE_URL,
        import.meta.env.VITE_APP_CHATWOOT_BASE_URL,
      ),
      VITE_APP_CHATWOOT_INBOX_IDENTIFIER: resolve(
        projectEnvVariables.VITE_APP_CHATWOOT_INBOX_IDENTIFIER,
        import.meta.env.VITE_APP_CHATWOOT_INBOX_IDENTIFIER,
      ),
      VITE_APP_GOOGLE_CLIENT_ID: resolve(
        projectEnvVariables.VITE_APP_GOOGLE_CLIENT_ID,
        import.meta.env.VITE_APP_GOOGLE_CLIENT_ID,
      ),
    },
  };
};
